import * as React from 'react';

import * as styles from './styles.css';
import { IDailyRentOfferForMobileSite } from '../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { BANNER_POSITIONS } from '../../constants';
import { BannerContainer } from '../../containers/BannerContainer';
import { ListingMobileFooterContainer } from '../../containers/ListingMobileFooterContainer';
import { ListingMobileSeoSectionContainer } from '../../containers/ListingMobileSeoSection';
import { OfferCardMobileContainer } from '../../containers/OfferCardMobileContainer';
import { OffersSuggestionsContainer } from '../../containers/OffersSuggestionsContainer';

interface IListingMobileOffersContentProps {
  offers: IDailyRentOfferForMobileSite[];
  onBreadcrumbClick(): void;
}

export const ListingMobileOffersContent = ({ offers, onBreadcrumbClick }: IListingMobileOffersContentProps) => {
  const offersLength = offers.length;

  const items = React.useMemo(
    () =>
      offers.reduce<React.ReactNode[]>((acc, offer, index) => {
        const position = index + 1;

        acc.push(
          <OfferCardMobileContainer
            key={offer.id}
            offer={offer}
            offerPosition={position}
            offersLength={offersLength}
          />,
        );

        if (position === 1) {
          acc.push(<OffersSuggestionsContainer key={`offers-suggestions-${offer.id}`} />);
        }

        if (BANNER_POSITIONS.includes(position)) {
          acc.push(<BannerContainer key={`mortgage-${offer.id}`} />);
        }

        return acc;
      }, []),
    [offers, offersLength],
  );

  return (
    <>
      <div className={styles['offers-list']}>{items}</div>
      <ListingMobileFooterContainer className={styles['pagination-adjustments']} />
      <ListingMobileSeoSectionContainer onBreadcrumbClick={onBreadcrumbClick} />
    </>
  );
};

ListingMobileOffersContent.displayName = 'ListingMobileOffersContent';
